import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Component, OnInit, Optional, inject } from '@angular/core';

@Component({
    selector: 'app-terminal-assignment-prompt',
    templateUrl: './terminal-assignment-prompt.component.html',
    styleUrls: ['./terminal-assignment-prompt.component.scss'],
})
export class TerminalAssignmentPromptComponent implements OnInit {
    modalCallback: any;
    modalData: any;
    weeklyTarget: number = null;
    readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

    constructor(@Optional() public modal: NzModalRef) {}

    ngOnInit(): void {
        if (this.modal) {
			this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
            this.modalCallback = this.modal.componentInstance.callback;
            this.weeklyTarget = this.modal?.componentInstance?.data?.terminalModel?.configuration?.performance?.weeklyPerformanceTarget;
            this.modalData = this.modal.componentInstance.data;
        }
    }

    submitForm() {
        this.modalCallback(true);
    }

    closeModal() {
        this.modalCallback(false);
    }
}
